import { UrlBuilderTypes } from "store/url-builder/types";

export const SetUrlBuilderPublicData = (data: any) => ({
 type: UrlBuilderTypes.SET_BUILDER_DATA,
 data,
});

export const SetBuilderPublicPermissions = (data: any) => ({
 type: UrlBuilderTypes.SET_BUILDER_PERMISSIONS,
 data,
});

export const UpdateBuilderPublicPermissions = (data: any) => ({
 type: UrlBuilderTypes.UPDATE_BUILDER_PERMISSIONS,
 data,
});
